import {isRTL} from '../../../../Localization';

export const MANAGEEOY = 'MANAGEEOY';
export const EOYWIZARD = 'EOYWIZARD';
export const eoyPromoCookie = 'eoyPromoShown';

export enum PromoText {
    title = 'title',
    textP1 = 'textP1',
    textP2_start = 'textP2_start',
    textsP2_link = 'textsP2_link',
    textP2_end = 'textP2_end',
    start = 'start',
    snooze = 'snooze',
    reject = 'reject'
}

const en = {
    title: 'Year-End Assistant',
    textP1: 'Priority takes you step-by-step through the year-end process, to ensure a smooth transition to the new fiscal year.',
    textP2_start: 'Define the user responsible for the year-end process using the',
    textsP2_link: '"Define Owner- Year-End Assistant"',
    textP2_end:
        'program or click Get Started to start the process now. You can switch owners at any time. The owner will receive automatic reminders to perform the different year-end steps at precisely the right time.',
    start: 'Get started',
    snooze: 'Remind me later',
    reject: 'Don’t show me again'
};

const he = {
    title: 'תהליך מעבר שנה',
    textP1: 'Priority מלווה אתכם צעד אחר צעד בכל הפעולות הנדרשות לתהליך מעבר שנה מהיר ויעיל.',
    textP2_start: 'הגדירו עכשיו את המשתמש האחראי לביצוע מעבר השנה בתוכנית',
    textsP2_link: '"הגדרת משתמש אחראי למעבר שנה"',
    textP2_end:
        'או לחצו על "להתחיל עכשיו" כדי להתחיל בתהליך ממש עכשיו. בכל שלב תוכלו להגדיר משתמש אחראי אחר. המשתמש האחראי יקבל תזכורות אוטומטיות לביצוע השלבים השונים בתהליך מעבר השנה בדיוק במועד המתאים.',
    start: 'להתחיל עכשיו',
    snooze: 'תזכירו לי אח"כ',
    reject: 'לא להציג שוב'
};

export const getHardcodedText = (key: PromoText): string => {
    return isRTL() ? he[key] : en[key];
};
